/**
 * Cdn Admin Destroy Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {string}
 */
window.cdnAdminDestroyFormatter = function(value, row) {
    if (row.original_type === 'directory') {
        return '<a href="javascript:void(0)" class="cdn-admin-destroy-directory text-danger" data-id="' + row.id + '"><i class="fa fa-trash"></i></a>';
    }
    return '<a href="javascript:void(0)" class="cdn-admin-destroy-file text-danger" data-id="' + row.id + '"><i class="fa fa-trash"></i></a>';
};
